import { Component, EventEmitter, Input, OnInit, Output, SimpleChanges, ViewChild } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { DxTabPanelComponent } from 'devextreme-angular';
import { Subscription } from 'rxjs';

import { AlertService } from '../../../core/alert.service';
import { AuthService } from '../../../core/auth.service';
import { DialogService } from '../../../core/dialog.service';
import { LoadingService } from '../../../core/loading.service';
import { RequestService } from '../../../core/request.service';
import { UtilityService } from '../../../core/utility.service';
import { BaseListComponent } from '../../base/base-list.component';
import { RouteAuthorities } from '../../base/base.models';
import { BaseService } from '../../base/base.service';
import { NotificationType, NotificationPriority, Notification } from '../notifications.models';
import { NotificationsService } from '../notifications.service';

@Component({
  selector: 'app-notifications-list',
  templateUrl: './notifications-list.component.html',
  styleUrls: ['./notifications-list.component.scss']
})
export class NotificationsListComponent extends BaseListComponent implements OnInit {
  @Output() closeNotificationsEvent = new EventEmitter();
  @Input('selectedTab') selectedTab: NotificationType;
  @ViewChild('tabPanel', { static: false }) tabPanel: DxTabPanelComponent;
  public locationSubscription: Subscription;

  public dataSources: any = {
    [NotificationType[NotificationType.SYSTEM]]: null,
    [NotificationType[NotificationType.PARTNER]]: null,
    [NotificationType[NotificationType.USER]]: null
  };
  public tabs: string[] = [
    NotificationType[NotificationType.SYSTEM].toLowerCase(),
    NotificationType[NotificationType.PARTNER].toLowerCase(),
    NotificationType[NotificationType.USER].toLowerCase()
  ];
  public selectedPriority: NotificationPriority;
  public currentNotification: Notification;
  public NotificationPriority = NotificationPriority;
  public showNewNotificationForm: boolean = false;
  public NotificationType = NotificationType;

  constructor(
    public authService: AuthService,
    public loadingService: LoadingService,
    public baseService: BaseService,
    public dialogService: DialogService,
    public alertService: AlertService,
    public utilityService: UtilityService,
    public requestService: RequestService,
    public translateService: TranslateService,
    private activatedRoute: ActivatedRoute,
    private notificationsService: NotificationsService,
    public router: Router
  ) {
    super(authService, loadingService, baseService, dialogService, alertService, utilityService, requestService, translateService);
    this.authorities = new RouteAuthorities(authService, alertService, 'S_NTF', 'R_NTF', null, null);
    this.creatable = this.authorities.create;
    this.editable = this.authorities.update;
    this.deletable = this.authorities.delete;
    this.activatable = this.authorities.update;
  }

  ngOnInit() {
    if (this.authService.hasAuthority('S_NTF'))
      this.tabs.push(NotificationType[NotificationType.SEND].toLowerCase());
    this.locationSubscription = this.activatedRoute.queryParams.subscribe((query) => {
      this.selectedPriority = query.priority && this.selectedPriority != query.priority ? query.priority.toUpperCase() : null; // for selected priority
      this.getTabData();
    });
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes.selectedTab.currentValue) // for tab from parent component
      this.getTabData();
  }

  public getTabData(): void {
    if (this.selectedTab) {
      setTimeout(() => {
        this.tabPanel.instance.option('selectedIndex', this.tabs.indexOf(this.selectedTab.toString().toLowerCase()));
      }, 200);
      this.dataSources[this.selectedTab.toString().toLowerCase()] = this.notificationsService.getNotifications(this.selectedTab, this.selectedPriority);
      this.currentNotification = null;
    }
  }

  public setPriority(priority?: NotificationPriority, navigateUrl?: string) {
    let query = { ...this.activatedRoute.snapshot.queryParams };

    if (!priority)
      delete query['priority']
    else
      query['priority'] = priority.toString().toLowerCase();

    this.router.navigate(navigateUrl ? [navigateUrl] : [], { queryParams: query });
  }

  public navigateToTab(event) {
    let queryParam = this.activatedRoute.snapshot.queryParamMap.get('priority');
    let currentPriority: NotificationPriority
    if (queryParam)
      currentPriority = this.utilityService.enumToArray(NotificationPriority).find(i => i == this.activatedRoute.snapshot.queryParamMap.get('priority').toUpperCase());
    this.setPriority(currentPriority, '/dashboard/notifications/' + event.addedItems[0]);
  }

  listSelectionChanged(event) {
    if (event && event.addedItems && event.addedItems.length > 0)
      if (this.currentNotification != event.addedItems[0]) {
        this.currentNotification = event.addedItems[0];
        if (!this.currentNotification.read)
          this.markAsUnread();
      }
  }

  public markAsUnread() {
    if (this.currentNotification && this.selectedTab.toString() != NotificationType[NotificationType.SEND]) {
      this.notificationsService.changeReadStatus(this.currentNotification.id, () => {
        this.currentNotification.read = !this.currentNotification.read;
        if (this.currentNotification.read == false)
          this.notificationsService.unreadNotificationsNumber++;
        else
          this.notificationsService.unreadNotificationsNumber--;
      });
    }
  }

  openOrder() {
    if (this.currentNotification.relatedEntity && this.currentNotification.relatedType)
      this.router.navigate([this.determineOrderUrl(), this.currentNotification.relatedEntity]);
  }

  private determineOrderUrl(): string {
    if (this.currentNotification.relatedType == 'CUSTOMER_ORDER') return `customer-orders`;
    if (this.currentNotification.relatedType == 'B2B_ORDER') return `b2b-orders`;
    return '';
  }

  closeNewNotificationForm(refresh: boolean = false) {
    this.showNewNotificationForm = false;
    if (refresh)
      this.getTabData();
  }
}